import {
  Rocket,
  Sparkles,
  Route,
  Bot,
  Grid2x2
} from 'lucide-react'
import { useCurrentUser } from '@contexts/currentUser'
import { useQuery } from '@hooks/graphql'
import TechnicalDifficultiesBanner from './TechnicalDifficultiesBanner'
import UpgradeBanner from '../educators/components/UpgradeBanner'
import MembershipPicker from './MembershipPicker'
import Navbar from './Navbar/Navbar'
import { useState } from 'react'
import NewClassroomModal from '../educators/pages/ClassroomList/NewClassroomModal'

const CLASSROOMS_QUERY = `
  query classrooms {
    classroomsPaginated(archived: false, perPage: 8) {
      nodes {
        id
        name
      }
    }
  }
`

const EducatorNav = () => {
  const { currentMembership } = useCurrentUser()
  const features = currentMembership?.organization?.features || []

  const { data: { classroomsPaginated: { nodes: classrooms = [] } = {} } = {}, refetch } = useQuery({
    queryKey: ['menu_classrooms', false],
    gqlQuery: CLASSROOMS_QUERY,
    onSuccess: (data) => {
    },
    onError: (error) => {
      console.error(error)
    }
  })

  const legacyFeaturesEnabled = features.includes('legacy_features')
  const technicalDifficultiesBannerEnabled = features.includes('technical_difficulties_banner')
  const educatorCreatorsEnabled = features.includes('educator_creators')

  const [showClassroomModal, setShowClassroomModal] = useState(false)

  const handleCloseClassroomModal = () => {
    setShowClassroomModal(false)
    refetch()
  }

  const navigation = [
    {
      name: 'Get Started',
      href: '/educators',
      icon: Rocket,
      exact: true
    },
    ...legacyFeaturesEnabled ? [{ name: 'Pathways', href: '/educators/courses', icon: Route }] : [],
    { name: 'Tutors', href: '/educators/tutors', icon: Bot },
    ...educatorCreatorsEnabled ? [{ name: 'Creators', href: '/educators/creators', icon: Sparkles }] : [],
    {
      name: 'Classrooms',
      href: '/educators/classrooms',
      create: () => setShowClassroomModal(true),
      items: [
        ...classrooms.slice(0, 8).map(classroom => ({
          name: classroom.name || '',
          href: `/educators/classrooms/${classroom.id || ''}`
        })),
        {
          name: 'All Classrooms',
          href: '/educators/classrooms',
          icon: Grid2x2,
          exact: true
        }
      ]
    }
  ]

  return (
    <>
      <Navbar>
        <Navbar.Header>
          <Navbar.Logo />
        </Navbar.Header>

        <Navbar.Content>
          <Navbar.List items={navigation} />
        </Navbar.Content>

        <Navbar.Footer>
          <If condition={technicalDifficultiesBannerEnabled}>
            <TechnicalDifficultiesBanner />
          </If>
          <UpgradeBanner />
          <div className='p-2'>
            <MembershipPicker />
          </div>
        </Navbar.Footer>
      </Navbar>
      <NewClassroomModal isOpen={showClassroomModal} onClose={handleCloseClassroomModal} />
    </>
  )
}

export default EducatorNav
